import { Badge, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import TaskAltOutlined from '@mui/icons-material/TaskAltOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import SearchIcon from '@mui/icons-material/Search';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

/** Height of the bar, so pages can leave room for it */
export const BOTTOM_NAV_HEIGHT = 64;

/** The five buttons along the bottom of a phone. "More" opens the full menu. */
export function BottomNav({ approvals, onMore }: { approvals: number; onMore: () => void }) {
  const { pathname } = useLocation();
  const current = ['/', '/approvals', '/shipments', '/search'].find((p) =>
    p === '/' ? pathname === '/' : pathname.startsWith(p),
  );
  return (
    <Paper
      elevation={0}
      sx={{
        display: { md: 'none' },
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 'appBar',
        borderTop: 1,
        borderColor: 'divider',
        borderRadius: 0,
        pb: 'env(safe-area-inset-bottom)',
      }}
    >
      <BottomNavigation showLabels value={current ?? 'more'} sx={{ height: BOTTOM_NAV_HEIGHT }}>
        <BottomNavigationAction component={RouterLink} to="/" value="/" label="Home" icon={<HomeOutlined />} />
        <BottomNavigationAction
          component={RouterLink}
          to="/approvals"
          value="/approvals"
          label="Approvals"
          icon={
            <Badge badgeContent={approvals} color="error">
              <TaskAltOutlined />
            </Badge>
          }
        />
        <BottomNavigationAction
          component={RouterLink}
          to="/shipments"
          value="/shipments"
          label="Shipments"
          icon={<LocalShippingOutlined />}
        />
        <BottomNavigationAction
          component={RouterLink}
          to="/search"
          value="/search"
          label="Search"
          icon={<SearchIcon />}
        />
        <BottomNavigationAction value="more" label="More" icon={<MoreHoriz />} onClick={onMore} />
      </BottomNavigation>
    </Paper>
  );
}
